export default "__VITE_ASSET__B4KS$0UG__"